(() => {
  const SECTION_SELECTOR = '.pasquini-estilo';

  const destroySwiper = (root) => {
    if (root._pasquiniEstiloSwiper) {
      root._pasquiniEstiloSwiper.destroy(true, true);
      delete root._pasquiniEstiloSwiper;
    }
    root.dataset.swiperReady = 'false';
  };

  const initSwiper = (root) => {
    if (!root || typeof window.Swiper === 'undefined') return;

    const swiperEl = root.querySelector('.pasquini-estilo__swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    if (root.dataset.swiperReady === 'true' && root._pasquiniEstiloSwiper) return;

    destroySwiper(root);

    const prevEl = root.querySelector('.pasquini-estilo__arrow--prev');
    const nextEl = root.querySelector('.pasquini-estilo__arrow--next');
    const scrollbarEl = root.querySelector('.pasquini-estilo__scrollbar');
    const gapDesktop = Number(root.dataset.gapDesktop) || 16;
    const gapMobile = Number(root.dataset.gapMobile) || 12;

    const syncNavVisibility = (swiperInstance) => {
      const needsNav = !swiperInstance.isLocked;
      root.classList.toggle('pasquini-estilo--has-nav', needsNav);
      if (prevEl) prevEl.hidden = !needsNav;
      if (nextEl) nextEl.hidden = !needsNav;
      if (scrollbarEl) scrollbarEl.hidden = !needsNav;
    };

    const swiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: gapMobile,
      watchOverflow: true,
      resistanceRatio: 0.65,
      navigation: {
        prevEl,
        nextEl,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        871: {
          spaceBetween: gapDesktop,
        },
      },
      on: {
        init: syncNavVisibility,
        resize: syncNavVisibility,
        update: syncNavVisibility,
        lock: syncNavVisibility,
        unlock: syncNavVisibility,
      },
    });

    syncNavVisibility(swiper);
    root.dataset.swiperReady = 'true';
    root._pasquiniEstiloSwiper = swiper;
  };

  const initAll = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSwiper);
  };

  const waitForSwiper = (attempt = 0) => {
    if (typeof window.Swiper !== 'undefined') {
      initAll();
      return;
    }

    if (attempt > 40) return;
    window.setTimeout(() => waitForSwiper(attempt + 1), 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSwiper());
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot =
      event.target.querySelector?.(SECTION_SELECTOR) || event.target.closest?.(SECTION_SELECTOR);
    if (sectionRoot) {
      sectionRoot.dataset.swiperReady = 'false';
      waitForSwiper();
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionRoot =
      event.target.querySelector?.(SECTION_SELECTOR) || event.target.closest?.(SECTION_SELECTOR);
    if (sectionRoot) destroySwiper(sectionRoot);
  });
})();
